import React from 'react';
import ServiceItem from './ServiceItem'
import service_item_icon from '../images/service-item-icon.jpg'
import service_item_2_icon from '../images/service-item-2-icon.jpg'
import service_item_3_icon from '../images/service-item-3-icon.jpg'
import service_item_4_icon from '../images/service-item-4-icon.jpg'
import service_item_5_icon from '../images/service-item-5-icon.jpg'
import service_item_6_icon from '../images/service-item-6-icon.jpg'
import service_item_7_icon from '../images/service-item-7-icon.jpg'
import service_item_8_icon from '../images/service-item-8-icon.jpg'
import './Middle.css'
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from "./GroupTitle";

export default function Middle() {
    return (
        <div className='middle'>
            <div className='middle-bg'/>
            <div className='service'>
                <GroupTitle>
                    <GroupTitleBackground>service</GroupTitleBackground>
                    <GroupTitleText>
                        <span>服务</span>
                        <GroupTitileOrange>行业</GroupTitileOrange>
                    </GroupTitleText>
                </GroupTitle>
                <div className='service-contents'>
                    <ServiceItem title="区域地质调查" src={service_item_icon}>
                        {/*&nbsp;  根据区域地质调查工作的需要，对工作区内重要的断层（含活动断层）、地层结构、含水层系以及特殊地质体的发育特征进行预测，最终实现地下目的层段范围内的精细成像，从而形成对以传统露头观测、钻探、槽探等手段为主的区域地质调查工作的有效补充。*/}
                        &nbsp;  对工作区内重要的断层（含活动断层）、地层结构、含水层系以及特殊地质体的发育特征进行预测，最终实现地下目的层段范围内的精细成像，从而形成对以传统露头观测、钻探、槽探等手段为主的区域地质调查工作的有效补充。
                    </ServiceItem>
                   <ServiceItem className="service-item-2" title="基础设施建设" src={service_item_2_icon}>
                      &nbsp;  主要致力于解决基础实施建设前期的各类工程地质问题，具体包括：铁路或公路等交通道路地基勘查、隧道沿线地质勘查、复杂地形区滑坡体结构探测、浅层活动断层调查、溶洞探测、裂隙发育带预测等。
                   </ServiceItem>
                   <ServiceItem className="service-item-3" title="军工" src={service_item_3_icon}>
                      &nbsp;  主要解决针对通讯线路或其他管线埋置情况的探测问题。
                   </ServiceItem>
                   <ServiceItem className="service-item-4" title="煤田安全生产" src={service_item_4_icon}>
                      &nbsp;  针对煤层采空区对煤田安全生产的不良影响，重点解决煤层采空区平面位置、埋深、大小等特征的探测问题，为煤田安全生产工作保驾护航。
                   </ServiceItem>
                   <ServiceItem className="service-item-5" title="城市地下空间探测" src={service_item_5_icon}>
                      &nbsp;  围绕“智慧城市”建设的需要，对城市地下空间进行精细探测，重点查明城市地下空间浅部地层精细结构、断层发育、含水层系、局部溶洞、地下管线埋置等特征，解决活动断层问题、溶洞塌陷、地基沉降、淤泥质土软塑性等不利工程地质问题。
                   </ServiceItem>
                   <ServiceItem className="service-item-6" title="油气资源勘查" src={service_item_6_icon}>
                      &nbsp;  围绕传统油气资源勘查中提高地震勘探静校正精度的问题，对浅地表低降速带厚度进行详细调查，为地震资料处理提供精细的静校正量，提高地震资料处理结果的精度。
                   </ServiceItem>
                   <ServiceItem className="service-item-7" title="金属矿产或地热资源调查" src={service_item_7_icon}>
                      &nbsp;  利用主动源及天然源浅层地震勘探方法，确定断裂破碎带或裂隙发育带，进而预测金属矿富集的蚀变矿化带或地下热水循环的优势通道位置，圈定矿产富集区或温泉有利区。
                   </ServiceItem>
                   <ServiceItem className="service-item-8" title="其他" src={service_item_8_icon}>
                      &nbsp;  针对某些特殊场地的工程地质或环境地质问题，进行精细探测，为后期治理制定方案。例如：垃圾场填埋治理等问题。
                   </ServiceItem>
                </div>
            </div>
        </div>
    )
}